/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import { discard } from 'app/_shared/events/cart'

/**
 * Deletes the cart denoted by `key` by calling `G.CART, G.DELETE`.
 *
 * If `key` is falsy, the currently active cart will be deleted (as per `delete` method
 * on the cart adapter).
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _discard = async (callback, module, component, event) => {
  const { key } = event?.detail || event || {}

  if (!key) throw new ReferenceError(`key of cart not defined, got: ${key}`)

  const data = { key }

  await discard(module, component, data, callback, event)
}

/**
 * Deletes the current cart
 *
 * @type {(function(...[*]): (*))|*}
 */
export const discardCurrent = curry(async (callback, module, component, event) => {
  const model = module[G.MODEL]
  const { [G.REF]: modelKey = null } = model[G.STATE] || {}

  await _discard(callback, module, component, { detail: { key: modelKey } })
})

export default curry(_discard)
